<template>
  <div>

        <v-data-table
        :headers="headers"
        :items="data"
        :expand="expand">
        <template v-slot:items="props">
            <td class="text-xs-center">
            {{props.item.billId}}
          </td>
          <td class="text-xs-center">
            {{props.item.billName}}
          </td>
          <td class="text-xs-center">
            {{props.item.data[0].updated}}
          </td>
          <td class="text-xs-center">
            {{props.item.data[0].bill_datefrom}}
          </td>
          <td class="text-xs-center">
            {{props.item.data[0].bill_dateto}}
          </td>
          <td class="text-xs-center">
            {{Math.round(props.item.data[0].rate_95th/10000)/100}}
          </td>
          <td class="text-xs-center">
            {{(Math.round(props.item.data[0].rate_95th/10000)/100)*65|currency}}
          </td>
          <!-- <td class="text-xs-center">
            {{props.item.data[0].updated}}
          </td>
          <td class="text-xs-center">
            {{props.item.data[0].updated}}
          </td> -->
          </template>
        </v-data-table>
</div>
</template>
<script>
export default {
  props: [
    "data"
  ],
  data() {
    return {
      channel_name: '',
      channel_fields: [],
      channel_entries: [],
      parse_header: [],
      parse_csv: [],
      sortOrders:{},
      expand: false,
      sortKey: '',
      items: [],
      matchedHeaders: [],
      headers: [
          {
          text: "Libre Bill ID",
          align: "center",
          value: "billId"
        },
        {
          text: "Name",
          align: "center",
          value: "billName"
        },
        {
          text: "Last Updated",
          align: "center",
          value: "data[0].updated"
        },
        {
          text: "Billed from",
          align: "center",
          value: "data[0].bill_datefrom"
        },
        {
          text: "Billed To",
          align: "center",
          value: "data[0].bill_dateto"
        },
        {
          text: "95th Percential (Mbps)",
          align: "center",
          value: "data[0].rate_95th"
        },
        {
          text: "Current Bill",
          align: "center",
          value: "data[0].rate_95th"
        },

          ]
    };
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    sortBy: function (key) {
      var vm = this
      vm.sortKey = key
      vm.sortOrders[key] = vm.sortOrders[key] * -1
    },
    csvJSON(csv){
      var vm = this
      var lines = csv.split("\n")
      var result = []
      var headers = lines[0].split(",")
      vm.parse_header = lines[0].split(",") 
      lines[0].split(",").forEach(function (key) {
        vm.sortOrders[key] = 1
      })
      
      // this.matchedHeaders=[]
      // let tempHeaders=[]
      // for(let i=0;i<headers.length;i++){

      // }
      lines.map(function(line, indexLine){
        if (indexLine < 1) return // Jump header line
        
        var obj = {}
        var currentline = line.split(",")
        
        headers.map(function(header, indexHeader){
          obj[header] = currentline[indexHeader]
        })
        
        result.push(obj)
      })
      
      result.pop() // remove the last item because undefined values
      this.items=result
      return result // JavaScript object
    },
    // xlsJSON(csv){
    //   var vm = this
    //   var lines = csv.split("\n")
    //   var result = []
    //   var headers = lines[0].split(",")
    //   vm.parse_header = lines[0].split(",") 
    //   lines[0].split(",").forEach(function (key) {
    //     vm.sortOrders[key] = 1
    //   })
      
    //   lines.map(function(line, indexLine){
    //     if (indexLine < 1) return // Jump header line
        
    //     var obj = {}
    //     var currentline = line.split(",")
        
    //     headers.map(function(header, indexHeader){
    //       obj[header] = currentline[indexHeader]
    //     })
        
    //     result.push(obj)
    //   })
      
    //   result.pop() // remove the last item because undefined values
      
    //   return result // JavaScript object
    // },
    loadCSV(e) {
      var vm = this
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsText(e.target.files[0]);
        // Handle errors load
        reader.onload = function(event) {
          var csv = event.target.result;
          vm.parse_csv = vm.csvJSON(csv)
          
        };
        reader.onerror = function(evt) {
          if(evt.target.error.name == "NotReadableError") {
            alert("Cannot read file !");
          }
        };
      } else {
        alert('FileReader are not supported in this browser.');
      }
    }
  }
}
</script>
<style scoped>
html, body {
  margin: 0;
  padding: 0;
}
body {
  margin: 32px auto;
}
.panel {
  border: 2px solid #dfdfdf;
  box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0 0;
  margin: 10px;
} 
.panel.panel-sm {
  max-width: 700px;
  margin: 10px auto;
}
.panel-heading {
  border-bottom: 2px solid #dfdfdf;
}
.panel-heading h1, .panel-heading h2, .panel-heading h3, .panel-heading h4, .panel-heading h5, .panel-heading h6 {
  margin: 0;
  padding: 0;
}
.panel-body .checkbox-inline {
  padding: 15px 20px;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>